import axios from "axios"
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom"

import Snackbar from "./components/Snackbar"

import NotFound from "./containers/404"
import CaseForm from "./containers/CaseForm"
import CaseList from "./containers/CaseList"
import CaseListNew from "./containers/CaseListNew"
import Charge from "./containers/Charge"
import Login from "./containers/Login"
import NewPassword from "./containers/NewPassword"
import FirstAccess from "./containers/FirstAccess"
import ResendCode from "./containers/ResendCode"
import LoginFromEmail from "./containers/LoginFromEmail"
import ReturnDocusign from "./containers/ReturnDocusign"
import { ProtectedLayout } from "./components/ProtectedLayout"

import "./styles/index.scss"
import Reports from "./containers/Reports"
import ShortUrlDocuSign from "./containers/ShortUrlDocuSign"

function App() {
  const dispatch = useDispatch()

  useEffect(() => {
    let loggedUser = localStorage.getItem("user")
    if (typeof loggedUser === "string") {
      loggedUser = JSON.parse(loggedUser)
      axios.defaults.headers.common["token"] = loggedUser.token
      dispatch({ type: "CHANGE_USER", payload: loggedUser })
    }
  }, [dispatch])

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/dc/:id" element={<ShortUrlDocuSign />} />
        <Route path="/returnDocusign" element={<ReturnDocusign />} />
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/login/:hash"
          element={<LoginFromEmail />}
        />
        <Route
          path="/login/chat/:hash"
          element={<Login />}
        />
        <Route path="nova-senha" element={<NewPassword />}>
          <Route path=":hash" element={<NewPassword />} />
        </Route>

        <Route path="/primeiro-acesso" element={<FirstAccess />} />
        <Route path="/reenviar-codigo" element={<ResendCode />} />

        <Route path="/painel" element={<ProtectedLayout allowRole={[1, 2]} />}>
          <Route path="meus-casos/:hash?" element={<CaseList />} />
          <Route path="meus-casos-new" element={<CaseListNew />} />
          <Route path="reports" element={<Reports />} />
          <Route path="novo-caso" element={<CaseForm />} />
        </Route>

        <Route path="/caso" element={<ProtectedLayout allowRole={[3]} />}>
          <Route path="" element={<Charge />} />
          <Route path=":caseId" element={<Charge />} />
        </Route>

        {/* <Route path="/teste" element={<Teste />} /> */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Snackbar />
    </BrowserRouter>
  )
}

export default App
